import React from "react";
import './common.css';

export default function SaralTranslate() {
  return (
    <div className="container">
      <header className="header">
        <h1 className="logo">Saral Platform</h1>
        <nav className="nav">
          <a href="/">Home</a>
          <a href="/SaralContact">CCaaS</a>
          <a href="/SaralModeration">Moderation</a>
        </nav>
      </header>

      <section className="intro" style={{
        backgroundImage: 'linear-gradient(rgba(102, 126, 234, 0.85), rgba(118, 75, 162, 0.85)), url(https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=1200&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <h2 className="intro-tagline">AI Translation Services</h2>
        <p className="intro-subtitle">Break language barriers with real-time, accurate translation</p>
      </section>

      <section className="features">
        <h3>What is AI Translation?</h3>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'left', padding: '0 2rem'}}>
          <p style={{fontSize: '1.3rem', marginBottom: '2rem', fontWeight: '500'}}>
            AI-powered translation services that enable seamless communication across languages. Our neural machine translation technology delivers human-quality translations for text, audio, and video content in real-time, supporting 100+ languages.
          </p>
        </div>
      </section>

      <section className="features">
        <h3>Multi-Format Translation</h3>
        <div className="feature-list">
          <div className="feature">
            <div className="feature-icon">📝</div>
            <h4>Text Translation</h4>
            <p>Translate documents, websites, emails, and messages with context-aware accuracy.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🎙️</div>
            <h4>Audio Translation</h4>
            <p>Convert spoken language to text and translate in real-time for calls, podcasts, and meetings.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🎥</div>
            <h4>Video Translation</h4>
            <p>Translate video subtitles, captions, and audio tracks to reach global audiences.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🌐</div>
            <h4>Website Localization</h4>
            <p>Automatically translate entire websites while preserving formatting and functionality.</p>
          </div>
        </div>
      </section>

      <section className="features">
        <h3>Key Features</h3>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'left', padding: '0 2rem'}}>
          <ul style={{fontSize: '1.1rem', lineHeight: '2', listStyle: 'disc', paddingLeft: '2rem'}}>
            <li><strong>100+ Languages:</strong> Support for major world languages including English, Spanish, Chinese, Arabic, Hindi, and more.</li>
            <li><strong>Real-Time Translation:</strong> Instant translation for live conversations, meetings, and customer support.</li>
            <li><strong>Context-Aware:</strong> Neural networks understand context, idioms, and cultural nuances for accurate translations.</li>
            <li><strong>Custom Terminology:</strong> Define industry-specific terms and brand names for consistent translations.</li>
            <li><strong>Batch Processing:</strong> Translate large volumes of content efficiently with bulk API calls.</li>
            <li><strong>Format Preservation:</strong> Maintain document formatting, HTML tags, and special characters.</li>
            <li><strong>Quality Confidence Scores:</strong> Get confidence ratings for each translation to ensure accuracy.</li>
            <li><strong>Human Review Integration:</strong> Seamlessly route translations to professional translators for review.</li>
          </ul>
        </div>
      </section>

      <section className="features">
        <h3>Translation Capabilities</h3>
        <div className="feature-list">
          <div className="feature">
            <div className="feature-icon">📄</div>
            <h4>Document Translation</h4>
            <p>Translate PDFs, Word docs, PowerPoint presentations, and spreadsheets while preserving layout.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">💬</div>
            <h4>Real-Time Chat</h4>
            <p>Enable multilingual customer support with instant message translation.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📞</div>
            <h4>Voice Translation</h4>
            <p>Translate phone calls and voice messages in real-time for global communication.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📺</div>
            <h4>Subtitle Generation</h4>
            <p>Automatically generate and translate subtitles for videos in multiple languages.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🛒</div>
            <h4>E-Commerce Localization</h4>
            <p>Translate product descriptions, reviews, and checkout flows for international markets.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📧</div>
            <h4>Email Translation</h4>
            <p>Translate incoming and outgoing emails automatically for global teams.</p>
          </div>
        </div>
      </section>

      <section className="features">
        <h3>Simple API Integration</h3>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'left', padding: '0 2rem'}}>
          <p style={{fontSize: '1.3rem', marginBottom: '1.5rem', fontWeight: '500'}}>
            Integrate translation into your applications in minutes:
          </p>
          <ul style={{fontSize: '1.1rem', lineHeight: '2', listStyle: 'disc', paddingLeft: '2rem'}}>
            <li><strong>RESTful API:</strong> Simple HTTP endpoints for text, audio, and video translation.</li>
            <li><strong>WebSocket Support:</strong> Real-time streaming translation for live conversations.</li>
            <li><strong>Auto-Detection:</strong> Automatically detect source language without manual input.</li>
            <li><strong>Multiple Output Formats:</strong> Get translations in JSON, XML, or plain text.</li>
            <li><strong>SDKs Available:</strong> Pre-built libraries for Python, JavaScript, Java, PHP, Ruby, and .NET.</li>
            <li><strong>Webhook Notifications:</strong> Receive callbacks when translations are complete.</li>
            <li><strong>Rate Limiting:</strong> Flexible pricing tiers based on usage volume.</li>
            <li><strong>Comprehensive Docs:</strong> Interactive API documentation with code examples and tutorials.</li>
          </ul>
        </div>
      </section>

      <section className="features">
        <h3>Use Cases</h3>
        <div className="feature-list">
          <div className="feature">
            <div className="feature-icon">🌍</div>
            <h4>Global Customer Support</h4>
            <p>Provide support in customers' native languages without hiring multilingual agents.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🛒</div>
            <h4>International E-Commerce</h4>
            <p>Expand to new markets by translating your entire store and product catalog.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📱</div>
            <h4>Mobile Apps</h4>
            <p>Localize your app interface and content for users worldwide.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🎓</div>
            <h4>E-Learning Platforms</h4>
            <p>Make educational content accessible to students in their preferred language.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📰</div>
            <h4>Media & Publishing</h4>
            <p>Translate news articles, blogs, and content for international audiences.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🏢</div>
            <h4>Enterprise Communication</h4>
            <p>Enable seamless collaboration across global teams and offices.</p>
          </div>
        </div>
      </section>

      <section className="features">
        <h3>Why Choose Saral Translation?</h3>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'left', padding: '0 2rem'}}>
          <ul style={{fontSize: '1.1rem', lineHeight: '2', listStyle: 'disc', paddingLeft: '2rem'}}>
            <li><strong>High Accuracy:</strong> Neural machine translation delivers human-quality results with 95%+ accuracy.</li>
            <li><strong>Fast Processing:</strong> Translate millions of words per second with low latency.</li>
            <li><strong>Cost-Effective:</strong> Pay only for what you use with transparent, per-character pricing.</li>
            <li><strong>Secure & Private:</strong> Enterprise-grade encryption and data privacy compliance (GDPR, SOC 2).</li>
            <li><strong>Continuous Learning:</strong> AI models improve over time with feedback and usage patterns.</li>
            <li><strong>24/7 Availability:</strong> Cloud-based service with 99.9% uptime SLA.</li>
          </ul>
        </div>
      </section>

      <section id="contact" className="contact">
        <h3>Ready to Go Global?</h3>
        <p>Let's discuss how Saral Platform can help you break language barriers and reach international audiences.</p>
        <p>Email us at <a href="mailto:mandar@saralplatform.com">mandar@saralplatform.com</a></p>
        <p>Call us at <a href="tel:770-378-8627">770-378-8627</a></p>
      </section>

      <footer className="footer">
        &copy; 2025 Saral Platform. All rights reserved.
      </footer>
    </div>
  );
}
